import {
  SIGNUP_FAILURE,
  SIGNUP_SUCCESS,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_SUCCESS,
  GET_CUSTOMER_SUCCESS,
  GET_CUSTOMER_FAILURE,
  UPDATE_PROFILE_SUCCESS,
  FORGET_PASSWORD_SUCCESS,
  GET_CUSTOMER_ADDRESS_SUCCESS,
  GET_CUSTOMER_ADDRESS_FAILURE,
  GET_CUSTOMER_ADDRESS_LOADING,
  GET_CANDIDATE_QUALIFICATIONS_SUCCESS,
  GET_CANDIDATE_QUALIFICATIONS_FAILURE,
  GET_CANDIDATE_EXPERIENCES_SUCCESS,
  GET_CANDIDATE_EXPERIENCES_FAILURE,
  GET_CANDIDATE_CERTIFICATIONS_SUCCESS,
  GET_CANDIDATE_CERTIFICATIONS_FAILURE,
  UPDATE_LOGIN_FIELD_SUCCESS,
  UPDATE_LOGIN_FIELD_FAILURE,
} from "../constants/actionTypes";
import {
  authKey_local_storage_key,
  userId_local_storage_key,
  userInfo_local_storage_key,
} from "../helpers/common";

const INITIAL_STATE = {
  profile: {
    verified: false,
    cart: [],
  },
  address: [],
  loading: true,
  qualifications: [],
  experiences: [],
  errors: null,
  certifications: [],
};

export default function customer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SIGNUP_SUCCESS:
    case LOGIN_SUCCESS: {
      console.group(`🔥 [REDUCER] ${action.type}`);
      console.log("1. Action Payload:", action.payload);

      // 1. UNIVERSAL EXTRACTION
      const userData =
        action.payload.customer || action.payload.data || action.payload;

      const token = action.payload.token || userData.token;

      // STORAGE
      if (token) {
        localStorage.setItem(authKey_local_storage_key, token);
      }

      const userId = userData.userId || userData.id || action.payload.userId;

      if (userId) {
        localStorage.setItem(userId_local_storage_key, userId);
      }

      localStorage.setItem(
        userInfo_local_storage_key,
        JSON.stringify(userData)
      );

      // 🎯 The server's role is the source of truth. A caller (e.g. the
      // signup form) may pass its own customer_type taken from the form
      // tab; never let that override what the server said.
      const serverType =
        userData.customerType ??
        userData.customerTypeId ??
        action.payload?.data?.customerType ??
        action.payload?.customerTypeId;

      const roleFields =
        serverType !== undefined && serverType !== null
          ? {
            customerType: Number(serverType),
            customerTypeId: Number(serverType),
            customer_type: Number(serverType) === 1 ? 1 : 2,
          }
          : {};

      console.log("2. Extracted User Data:", userData);
      console.log("3. Resolved Server Role Type:", serverType);
      console.log("4. Applied Role Fields:", roleFields);

      const updatedProfile = {
        ...state.profile,
        ...userData,
        ...roleFields,

        id: userId,

        username: userData.username || userData.name || "",

        name: userData.name || userData.username || "",

        verified: true,
        cart: [],
      };

      console.log("5. Final Saved Redux Profile:", updatedProfile);
      console.groupEnd();

      return {
        ...state,
        profile: updatedProfile,
        loading: false,
      };
    }

    case SIGNUP_FAILURE:
      console.log("❌ [REDUCER] SIGNUP_FAILURE:", action.payload);
      return {
        ...state,
        errors: action.payload?.response?.data?.[0]?.message || action.payload,
      };

    case GET_CUSTOMER_SUCCESS: {
      console.group("🔵 [REDUCER] GET_CUSTOMER_SUCCESS");
      console.log("1. Action Payload:", action.payload);

      const user = action.payload.data?.data || action.payload.data;
      const serverType = user?.customerType ?? user?.customerTypeId;

      console.log("2. Extracted User Object:", user);
      console.log("3. Extracted Server Role Type:", serverType);

      const updatedProfile = {
        ...state.profile,
        ...action.payload.data,
        id: user?.userId || user?.id || state.profile?.id,
        email: user?.email || state.profile?.email,
        name: action.payload.data?.name || state.profile?.name,
        // 🎯 Server role (0 = candidate, 1 = employer) always wins over
        // whatever the signup flow stored.
        ...(serverType !== undefined && serverType !== null
          ? {
            customerType: Number(serverType),
            customerTypeId: Number(serverType),
            customer_type: Number(serverType),
          }
          : {}),
      };

      console.log("4. Updated Redux Profile State:", updatedProfile);
      console.groupEnd();

      return {
        ...state,
        loading: false,
        profile: updatedProfile,
      };
    }

    case LOGIN_FAILURE:
      console.log("❌ [REDUCER] LOGIN_FAILURE:", action.payload);
      return {
        ...state,
        errors: action.payload.error,
      };

    case LOGOUT_SUCCESS:
      console.log("🚪 [REDUCER] LOGOUT_SUCCESS - Clearing Storage & Profile");
      localStorage.removeItem(authKey_local_storage_key);
      localStorage.removeItem(userId_local_storage_key);
      localStorage.removeItem(userInfo_local_storage_key);

      return {
        ...state,
        profile: { verified: false },
        loading: false,
      };

    case GET_CUSTOMER_FAILURE:
      console.log("❌ [REDUCER] GET_CUSTOMER_FAILURE:", action.payload);
      return {
        ...state,
        profile: { verified: false },
        loading: false,
        errors: action.payload.message,
      };

    case UPDATE_PROFILE_SUCCESS: {
      console.group("🔥 [REDUCER] UPDATE_PROFILE_SUCCESS");
      console.log("1. Action Payload:", action.payload);

      let updatedFields = action.payload;

      if (
        updatedFields?.data !== undefined &&
        updatedFields?.status !== undefined
      ) {
        updatedFields = updatedFields.data;
      }
      if (
        updatedFields?.data !== undefined &&
        updatedFields?.success !== undefined
      ) {
        updatedFields = updatedFields.data;
      }

      const preservedCustomerType =
        updatedFields?.customerType !== undefined &&
          updatedFields?.customerType !== null
          ? updatedFields.customerType
          : state.profile?.data?.customerType ?? state.profile?.customerType;

      const preservedRole =
        updatedFields?.role !== undefined && updatedFields?.role !== null
          ? updatedFields.role
          : state.profile?.data?.role ?? state.profile?.role;

      // 🎯 Resolve the display name from every field name we've seen used
      // across different forms/endpoints, so no matter which one the
      // backend actually returns, NavBar picks it up immediately.
      const resolvedName =
        updatedFields?.fullName ||
        updatedFields?.name ||
        updatedFields?.companyName ||
        updatedFields?.username ||
        state.profile?.data?.name ||
        state.profile?.name;

      const updatedProfile = {
        ...state.profile,
        customerType: preservedCustomerType,
        customerTypeId: preservedCustomerType,
        role: preservedRole,
        name: resolvedName, // top-level, since NavBar checks this first
        fullName: resolvedName,
        data: {
          ...state.profile?.data,
          ...updatedFields,
          customerType: preservedCustomerType,
          role: preservedRole,
          name: resolvedName, // also nested, since NavBar checks this second
        },
      };

      console.log("2. Updated Profile State:", updatedProfile);
      console.groupEnd();

      return {
        ...state,
        profile: updatedProfile,
        loading: false,
      };
    }

    case UPDATE_LOGIN_FIELD_FAILURE:
      return {
        ...state,
        errors: action.payload?.message || "Failed to update login field",
      };

    case FORGET_PASSWORD_SUCCESS:
      return {
        ...state,
        profile: { ...state.profile, ...action.payload.data },
      };

    case GET_CANDIDATE_QUALIFICATIONS_SUCCESS:
      return {
        ...state,
        qualifications: action.payload.data,
      };

    case GET_CANDIDATE_QUALIFICATIONS_FAILURE:
      return {
        ...state,
        qualifications: [],
      };

    case GET_CANDIDATE_EXPERIENCES_SUCCESS:
      return {
        ...state,
        experiences: action.payload.data,
      };

    case GET_CANDIDATE_EXPERIENCES_FAILURE:
      return {
        ...state,
        experiences: [],
      };

    case GET_CANDIDATE_CERTIFICATIONS_SUCCESS:
      return {
        ...state,
        certifications: action.payload.data,
      };

    case GET_CANDIDATE_CERTIFICATIONS_FAILURE:
      return {
        ...state,
        certifications: [],
      };

    case GET_CUSTOMER_ADDRESS_LOADING:
      return { ...state, loading: true, address: [] };

    case GET_CUSTOMER_ADDRESS_SUCCESS:
      return { ...state, loading: false, address: action.payload.data };

    case GET_CUSTOMER_ADDRESS_FAILURE:
      return { ...state, error: action.payload.error };

    default:
      return state;
  }
}
